const APPRAISER_TAB_VALUES = {
  APPRAISER_PROFILE: 'appraiser-profile',
  EDIT_LICENSE: 'edit-license',
  CERTIFICATION_PATHWAY_PROGRESS: 'certification-pathway-progress'
};

const CERTIFICATION_PATHWAY_PROGRESS_APPRAISER_TAB = {
  value: APPRAISER_TAB_VALUES.CERTIFICATION_PATHWAY_PROGRESS,
  displayName: 'Certification Pathway Progress',
  urlTemplate: '/user-management/certification-pathway-progress'
};

export const BASIC_APPRAISER_TABS = [
  {
    value: APPRAISER_TAB_VALUES.APPRAISER_PROFILE,
    displayName: 'Appraiser Profile',
    urlTemplate: '/user-management/{orgId}/appraiser-profile/{userId}'
  },
  {
    value: APPRAISER_TAB_VALUES.EDIT_LICENSE,
    displayName: 'Edit License',
    urlTemplate: '/user-management/edit-license'
  }
];

export const ALL_APPRAISER_TABS = [
  ...BASIC_APPRAISER_TABS,
  CERTIFICATION_PATHWAY_PROGRESS_APPRAISER_TAB
];
